let version = 0;
const listeners = new Set<() => void>();

export function bumpFindings(): void {
  version += 1;
  for (const listener of listeners) listener();
}

export function subscribeFindings(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function getFindingsVersion(): number {
  return version;
}
